import { Formik, Form } from 'formik';
import {
    initialValues,
    validationSchema_FormAuLogin,
} from 'blocks/Form/data/validation';
import Submit from 'blocks/Form/fields/Submit';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import ProfessionalEmail from 'blocks/Form/fields/ProfessionalEmail';
import LearningAppRole from 'blocks/Form/fields/LearningAppRole';
import LearningAppSpecialty from 'blocks/Form/fields/LearningAppSpecialty';
import Location from 'blocks/Form/fields/Location';
import HospitalName from 'blocks/Form/fields/HospitalName';
import PostalCode from 'blocks/Form/fields/PostalCode';
import AHPRAnumber from 'blocks/Form/fields/AHPRAnumber';
import AdditionalInformation from 'blocks/Form/fields/AdditionalInformation';
import { signIn } from 'next-auth/react';

const restrictedEmails = [
    '@gmail.com',
    '@hotmail.com',
    '@yahoo.com',
    '@mac.om',
    '@aol.com',
    '@msn.com',
    '@live.com',
    '@outlook.com',
    '@cox.net',
    '@inbox.com',
    '@mail.com',
];

/* === CORP - Edwards Learning App === */

const FormAuLogin = ({ handleSubmit, isPending, fields }) => {
    const {
        first_name,
        last_name,
        professional_email_address,
        registration_number,
        learning_app_role,
        learning_app_specialty,
        hospital_institution,
        location,
        hospital_name,
        additional_information,
        registering,
        validation,
        all_required_fields,
    } = fields;
    location.Country = 'AU';
    learning_app_specialty.placeholder = 'Select your Speciality';
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit('docebo-au', values)}
            validationSchema={validationSchema_FormAuLogin(validation)}
        >
            {(formik) => (
                <Form className="form form--lg">
                    <div className="row-gap-0">
                        <FirstName
                            label={first_name}
                            initialValues={initialValues}
                        />
                        <LastName
                            label={last_name}
                            initialValues={initialValues}
                        />
                        <ProfessionalEmail
                            label={professional_email_address}
                            initialValues={initialValues}
                        />
                        <LearningAppRole
                            data={learning_app_role}
                            initialValues={initialValues}
                        />
                        <LearningAppSpecialty
                            data={learning_app_specialty}
                            initialValues={initialValues}
                        />
                        <AHPRAnumber
                            label={registration_number}
                            initialValues={initialValues}
                        />
                    </div>
                    <p>
                        <strong>{hospital_institution}</strong>
                    </p>
                    <div className="row-gap-0">
                        <HospitalName
                            label={hospital_name}
                            initialValues={initialValues}
                        />
                        <Location
                            data={location}
                            formik={formik}
                            initialValues={initialValues}
                        />
                    </div>
                    <AdditionalInformation data={additional_information} />
                    {formik.values.ProfessionalEmailAddress?.includes(
                        '@edwards.com'
                    ) && (
                        <h3>
                            Edwards employee? Please login with{' '}
                            <a
                                onClick={() =>
                                    signIn('azure-ad', {
                                        callbackUrl: sessionStorage?.prevUrl,
                                    })
                                }
                            >
                                SSO
                            </a>
                        </h3>
                    )}
                    {restrictedEmails.some((mail) =>
                        formik.values.ProfessionalEmailAddress?.toLowerCase()?.includes(
                            mail
                        )
                    ) && <h3>Please use professional email address.</h3>}
                    {!restrictedEmails.some((mail) =>
                        formik.values.ProfessionalEmailAddress?.toLowerCase()?.includes(
                            mail
                        )
                    ) &&
                        !formik.values.ProfessionalEmailAddress?.includes(
                            'edwards.com'
                        ) && (
                            <Submit
                                formik={formik}
                                isPending={isPending}
                                pendingText={registering}
                                validation={all_required_fields}
                            >
                                Create Account
                            </Submit>
                        )}
                </Form>
            )}
        </Formik>
    );
};

export default FormAuLogin;
